export default __webpack_public_path__ + "static/media/alert-sign-icon.c510f09d.svg";